import {formItemTypeEnum} from '@sttedra_ui/framework';

import {useValidations} from '@sttedra_ui/framework';

import {useEventListener} from '@vueuse/core';

const {email} = useValidations();

export default function({data}) {
  return {
    items: [
      {
        field: 'email',
        type: formItemTypeEnum.INPUTTEXT,
        label: 'Correo electrónico',
        value: data?.email || null,
        errorMessage: 'El correo electrónico no es válido',
        rules: {
          email,
        },
        clear: false,
        floatDisabled: true,
        properties: {
          placeholder: '',
        },
        events: {
          onMounted: async () => {
            const field = document.querySelector('.form__item--email input');
            if (field) {
              field.setAttribute('aria-label', 'Correo electrónico');
            }
          },
        },
      },
      {
        field: 'emailValidation',
        type: formItemTypeEnum.INPUTTEXT,
        label: 'Verificación correo electrónico',
        value: data?.email || null,
        errorMessage: 'Los correos electrónicos no coinciden',
        clear: false,
        floatDisabled: true,
        rules: {
          email,
        },
        properties: {
          placeholder: '',
        },
        events: {
          onMounted: async () => {
            const field = document.querySelector(
              '.form__item--emailvalidation input',
            );
            if (field) {
              field.setAttribute(
                'aria-label',
                'Verificación correo electrónico',
              );
            }
          },
        },
      },
      {
        field: 'phone',
        type: formItemTypeEnum.INPUTTEXT,
        label: 'Teléfono móvil',
        clear: false,
        floatDisabled: true,
        value: data?.phone || null,
        errorMessage: 'El teléfono no es válido',
        properties: {
          date: 'phone',
          placeholder: '+34 999 999 999',
        },
        events: {
          onMounted: async (updater, eventHelpers) => {
            const field = document.querySelector('.form__item--phone input');
            if (field) {
              field.setAttribute('aria-label', 'Teléfono');

              useEventListener(field, 'focus', (event) => {
                if (event.target.value === '') {
                  eventHelpers.changeFieldValue('phone', '+34');
                }
              });

              useEventListener(field, 'blur', (event) => {
                if (!event.target.value) {
                  event.target.classList.remove('p-invalid');
                  return;
                }

                const regexExtension = /^\+\d{2,3}$/;

                if (regexExtension.test(event.target.value)) {
                  eventHelpers.changeFieldValue('phone', '');
                  event.target.classList.remove('p-invalid');
                  return;
                }

                const regex = /^\+\d{2,3} ?\d{3} ?\d{3} ?\d{3}$/;
                if (!regex.test(event.target.value)) {
                  event.target.classList.add('p-invalid');

                  if (
                    event.target.parentNode.parentNode.querySelector(
                      '.form__group__error',
                    )
                  ) {
                    return;
                  }

                  const divField = document.createElement('div');
                  divField.setAttribute('class', 'form__group__error');

                  const smallField = document.createElement('small');
                  smallField.setAttribute('class', 'p-error');
                  smallField.setAttribute('aria-hidden', 'false');
                  smallField.setAttribute('role', 'alert');
                  smallField.setAttribute(
                    'aria-label',
                    'El teléfono no es válido',
                  );
                  smallField.innerText =
                    'El teléfono no es válido. Formato: +34 999 999 999';

                  divField.appendChild(smallField);
                  event.target.parentNode.parentNode.appendChild(divField);
                } else {
                  event.target.classList.remove('p-invalid');
                  const divField =
                    event.target.parentNode.parentNode.querySelector(
                      '.form__group__error',
                    );
                  if (divField) {
                    divField.remove();
                  }
                }
              });
            }
          },
        },
      },
    ],
  };
}
